import classNames from 'classnames';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { SingleLineTruncate } from '../../common/LineTruncate';

import css from './BooksMenu.module.scss';

interface Props {
  className?: string;
  menuName: string;
  price?: string;
  duration?: number; // second
}

const BooksMenu = ({
  className,
  intl,
  menuName,
  price,
  duration,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksMenu, className);

  return (
    <div className={classes}>
      <SingleLineTruncate maxLine={2} text={menuName} />
      <span className={css.BooksMenu__MenuDetail}>
        {duration && (
          <span className={css.BooksMenu__Time}>
            <FormattedMessage
              id="books.booksMenu.time"
              values={{ time: intl.formatNumber(duration / 60) }}
            />
          </span>
        )}
        {price && (
          <FormattedMessage id="books.booksMenu.price" values={{ price }} />
        )}
      </span>
    </div>
  );
};

export default injectIntl(BooksMenu);
